module.exports = __webpack_public_path__ + "static/img/7.2835396.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/7.jpeg
// module id = oAJJ
// module chunks = 3